import type { Transaction } from "./finance.ts";

/** Fields read by cash, budget and profit calculators. ONLY for aggregates:
 * list/search/details/exports/drafts/writes must always use current raw rows.
 */
export const calculationFields = ["id", "amount", "date", "direction", "category", "subcategory", "categoryRuleConflict", "financialAccount", "financialMappingSource", "uniqueCode", "businessUnit", "businessUnits", "deletedAt"] as const satisfies readonly (keyof Transaction)[];
function sameValue(a: unknown, b: unknown): boolean {
  return Object.is(a, b) || (Array.isArray(a) && Array.isArray(b) && a.length === b.length && a.every((value, i) => Object.is(value, b[i])));
}
/** Bounded to one array; immutable React rows required. Membership/order and
 * every relevant value invalidate the input. No growing per-ID version cache.
 */
export function createCalculationRowsSelector(fields: readonly (keyof Transaction)[] = calculationFields) {
  let previous: Transaction[] | undefined;
  return (rows: Transaction[]): Transaction[] => {
    if (previous === rows) return previous;
    if (previous?.length === rows.length && rows.every((row, index) => {
      const old = previous![index];
      return old === row || fields.every((field) => sameValue(old[field], row[field]));
    })) return previous;
    previous = rows; return rows;
  };
}
